import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapHasNexPage } from '../../mappers';
import { THasNexPage } from '../../types/hasNexPage';
import { TReduxActions } from '../../types/redux';

const defaultState: THasNexPage = false;

export function hasNexPageReducer(state: THasNexPage = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapHasNexPage(action.payload);
  }

  return state;
}
